import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initSentry, maybeTriggerDevSentryTest } from './lib/sentry'

initSentry()
maybeTriggerDevSentryTest()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
